import React from 'react';

interface IntelyxLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export const IntelyxLogo: React.FC<IntelyxLogoProps> = ({ 
  width = 32, 
  height = 32, 
  className = "" 
}) => {
  return (
    <img 
      src="/Intelyx.png"
      alt="Intelyx AI Logo"
      width={width} 
      height={height} 
      className={className}
      style={{ 
        objectFit: 'contain',
        borderRadius: '4px' // Optional: slight rounding for modern look
      }}
    />
  );
};